import { Star } from "lucide-react";
import { Reveal, RevealLine } from "@/components/Motion";
import { TESTIMONIALS, REVIEW_STATS } from "@/data/site";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="py-24 sm:py-32 bg-[#EAF0F6]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <p className="kicker mb-4">Reviews</p>
            <h2 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1C2A39] leading-[1.05]">
              <RevealLine>Loved by Adelaide</RevealLine>
              <RevealLine delay={0.1}>homes & offices.</RevealLine>
            </h2>
          </div>
          <Reveal delay={0.2}>
            <div data-testid="review-rating" className="bg-white rounded-2xl border border-slate-200 px-6 py-5 flex items-center gap-4">
              <span className="font-display font-extrabold text-4xl text-[#1C2A39]">{REVIEW_STATS.average}</span>
              <div>
                <div className="flex gap-0.5">
                  {[0, 1, 2, 3].map((i) => <Star key={i} size={16} className="text-[#F59E0B]" fill="#F59E0B" />)}
                  <span className="relative inline-block">
                    <Star size={16} className="text-[#F59E0B]" />
                    <span className="absolute inset-0 overflow-hidden" style={{ width: "70%" }}>
                      <Star size={16} className="text-[#F59E0B]" fill="#F59E0B" />
                    </span>
                  </span>
                </div>
                <p className="text-xs text-[#475569] mt-1">Based on {REVIEW_STATS.count} Google reviews</p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.08}>
              <div className="h-full bg-white rounded-3xl p-7 border border-slate-200 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex gap-0.5">
                    {Array.from({ length: t.rating }).map((_, k) => (
                      <Star key={k} size={16} className="text-[#F59E0B]" fill="#F59E0B" />
                    ))}
                    {Array.from({ length: 5 - t.rating }).map((_, k) => (
                      <Star key={`e${k}`} size={16} className="text-slate-200" fill="#e2e8f0" />
                    ))}
                  </div>
                  <span className="text-[10px] uppercase tracking-wider text-[#475569] font-semibold">Google</span>
                </div>
                <p className="text-[#1C2A39] text-[15px] leading-relaxed flex-1">"{t.text}"</p>
                <div className="mt-6 pt-5 border-t border-slate-100">
                  <p className="font-semibold text-[#1C2A39] text-sm">{t.name}</p>
                  <p className="text-[#475569] text-xs">{t.suburb}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
